const formatFullName = (firstname?: string | null, middleinitial?: string | null, lastname?: string | null): string =>
  `${firstname ?? ''} ${middleinitial ?? ''} ${lastname ?? ''}`.replace(/\s+/g, ' ').trim();
export default formatFullName;
